import { CustomerRow } from './CustomersV2.types';

/**
 * The API substitutes this string for a missing business name at the DB level
 * (`buyer_name` in `shared_spending_limits/interface.py`), so `company_name` is
 * never null or empty. Treat it as "no name yet" rather than a real company.
 */
const AWAITING_DETAILS = 'Awaiting details';

export const hasCompanyName = (row: CustomerRow): boolean =>
  Boolean(row.company_name) && row.company_name !== AWAITING_DETAILS;

export const companyNameLabel = (row: CustomerRow): string =>
  hasCompanyName(row) ? row.company_name : AWAITING_DETAILS;
